module.exports = __webpack_public_path__ + "static/media/3.12a1a498.png";